<script lang="ts">
    import Box from './_wrappers/Box.svelte';
    import DisplayComponent from '$lib/components/DisplayComponent/DisplayComponent.svelte';
    import clsx from 'clsx';

    // Types
    import type { Box as BoxType, Component } from '$lib/types/Components/SharedTypes';
    import type { Theme, TransitionEffect } from '$lib/types/Theme';
    import type { Field } from '$lib/types/Field';
    import type { TrackingProperty } from '$lib/types/TrackingProperty';
    import type { Language } from '$lib/types/Language';
    import type { ResultMapping } from '$lib/types/ResultMapping';

    export let box: BoxType;
    export let childComponents: Component[] = [];
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'default';
    export let resultMapping: ResultMapping;
    export let theme: Theme;
    export let nextPage = '';
    export let currentPage = '';
    export let campaignId = '';
    export let companyId = '';
    export let cookiesEnabled = false;
    export let fields: Field[] = [];
    export let firstResultPage = '';
    export let trackingProperties: TrackingProperty[] = [];
    export let language: Language = 'de';

    const columnCount = childComponents.length;

    const isSingleColumn = columnCount === 1;
    const isInMultiColumn = columnCount > 1;
</script>

<Box {...box} {transitionDelay} {transitionEffect} desktop>
    <div
        class={clsx('grid grid-cols-1 gap-6 px-4 lg:gap-8 lg:px-8 xl:gap-12 xl:px-12', {
            'md:grid-cols-2': !isSingleColumn,
            'lg:grid-cols-3': columnCount === 3,
            'xl:grid-cols-4': columnCount >= 4,
        })}
    >
        <!-- GridColumns -->
        {#each childComponents as component, index}
            <DisplayComponent
                id={component._id}
                componentType={component.componentType}
                childComponents={component.components}
                content={component.content}
                layout={{
                    isInColumn: false,
                    isInSingleColumn: isSingleColumn,
                    isInFramedColumn: false,
                    isInMultiColumn,
                    columnCount,
                }}
                {language}
                {campaignId}
                {companyId}
                {cookiesEnabled}
                {theme}
                {nextPage}
                {currentPage}
                {resultMapping}
                {fields}
                {firstResultPage}
                {trackingProperties}
                {index}
            />
        {/each}
    </div>
</Box>
